import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import Image from 'components/ImageV2';
import { IMAGE_BG_COLOR } from 'constants/images';
import { MEDIA_TYPES } from 'constants/media';
import { largeUp } from 'constants/mediaQueries';
import Theme from 'styles/theme';
import I18n from 'utils/I18n';

const Thumbnails = ({ slides, currentSlideIndex, setCurrentSlideIndex }) => {
  return (
    <div className="ThumbnailsCarousel">
      {slides?.map((slide, index) => {
        const { src, description, type, poster } = slide;
        return (
          <button
            // So screen readers can read the slide number correctly (1-based)
            aria-label={I18n.localize('carousel.viewSlide', { slideIndex: index + 1 })}
            className={classNames('ThumbnailButton', {
              'ThumbnailButton--active': currentSlideIndex === index,
            })}
            data-testid="carousel-thumbnail-button"
            key={src}
            onClick={() => setCurrentSlideIndex(index)}
          >
            <Image
              alt={description}
              data-testid={src}
              width={120}
              height={120}
              src={type === MEDIA_TYPES.VIDEO ? poster : src}
              transformations={{
                backgroundColor: IMAGE_BG_COLOR,
              }}
              coverParentNode
            />
          </button>
        );
      })}
      <style jsx>{`
        .ThumbnailsCarousel {
          flex: 1;
          max-width: 10%;
          flex-direction: column;
          justify-content: ${slides.length === 8 ? 'space-between' : 'flex-start'};
          gap: 1.1304%; // 7 gaps between 8 thumbnails
          display: none;
        }

        @media ${largeUp} {
          .ThumbnailsCarousel {
            display: flex;
          }
        }
        .ThumbnailButton {
          cursor: pointer;
          aspect-ratio: 1/1;
          border-radius: ${Theme.get('border-radius-px')};
          border: 2px solid transparent;
          overflow: hidden;
          padding: 0;
        }
        .ThumbnailButton--active {
          border-color: ${Theme.get('colors-black-80')};
        }
      `}</style>
    </div>
  );
};

Thumbnails.propTypes = {
  slides: PropTypes.arrayOf(
    PropTypes.shape({
      src: PropTypes.string,
      description: PropTypes.string,
      type: PropTypes.string,
      poster: PropTypes.string,
      sys: PropTypes.shape({
        id: PropTypes.string,
      }),
    })
  ),
  currentSlideIndex: PropTypes.number,
  setCurrentSlideIndex: PropTypes.func,
  colorwayHandle: PropTypes.string,
};

Thumbnails.defaultProps = {
  slides: [],
  currentSlideIndex: 0,
  setCurrentSlideIndex: () => {},
  colorwayHandle: '',
};

export default Thumbnails;
